var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerticalDotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 14,
    viewBox: "0 0 4 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.44461 1.44531C3.44461 0.715855 2.82042 0.124512 2.05043 0.124512C1.28045 0.124512 0.65625 0.715855 0.65625 1.44531C0.65625 2.17477 1.28045 2.76612 2.05043 2.76612C2.82042 2.76612 3.44461 2.17477 3.44461 1.44531ZM3.44461 6.72853C3.44461 5.99907 2.82042 5.40772 2.05043 5.40772C1.28045 5.40772 0.65625 5.99907 0.65625 6.72853C0.65625 7.45799 1.28045 8.04933 2.05043 8.04933C2.82042 8.04933 3.44461 7.45799 3.44461 6.72853ZM3.44461 12.0117C3.44461 11.2823 2.82042 10.6909 2.05043 10.6909C1.28045 10.6909 0.65625 11.2823 0.65625 12.0117C0.65625 12.7412 1.28045 13.3325 2.05043 13.3325C2.82042 13.3325 3.44461 12.7412 3.44461 12.0117Z",
    fill: "#3E3E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDotIcon);
export default __webpack_public_path__ + "static/media/vertical-dot-icon.f6343777cb1fc63cc7de659261435eb8.svg";
export { ForwardRef as ReactComponent };